// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3qPhz","filesListContainer":"PosDisputesFiles_filesListContainer__3RC4j","filesButton":"PosDisputesFiles_filesButton__36uSK"};